<template>
  <div class="scheduling-unavailable">
    <BaseAlert
      :hg-value="true"
      hg-lead-in="Online booking unavailable"
      hg-type="info">
      Please contact us via phone or email to schedule an appointment.
    </BaseAlert>

    <v-layout row wrap>
      <v-flex v-if="company.phone" v-bind="metaBindings">
        <p>
          <strong>Phone</strong>
          <br/>
          {{company.phone}}
        </p>
      </v-flex>

      <v-flex v-if="company.email" v-bind="metaBindings">
        <p>
          <strong>Email</strong>
          <br/>
          <a :href="`mailto:${company.email}`">{{company.email}}</a>
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { Components } from '@spectorasoftware/homegauge-vue';
import { mapState } from 'vuex';

const { BaseAlert } = Components;

export default {
  components: {
    BaseAlert,
  },
  data() {
    return {
      metaBindings: {
        xs12: true,
        sm6: true,
        'py-2': true,
        'text-sm-center': true,
      },
    };
  },
  computed: {
    ...mapState('Company', {
      company: state => state.company,
    }),
  },
};
</script>

<style lang="scss" scoped>
.scheduling-unavailable {
  padding-top: 30px;
}
</style>
